<template>
	<div class="wrap">
		<div class="title">
			<div class="title_left">人员管理</div>
		</div>
		<div v-if="true" class="innerBox">
			<ErrorTemplate></ErrorTemplate>
		</div>
		<div v-if="false" class="innerBox">
			<div>
				<el-input placeholder="姓名, 职务, 联系方式, 业务权限" class="w300 seekIpt mr20" v-model="input">
					<i @click="search" slot="suffix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<el-select v-model="value1" @change="permissionsChoose" multiple collapse-tags class="mr20" placeholder="请选择">
					<el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value"></el-option>
				</el-select>
				<el-select v-model="value2" @change="avaliableChoose" class="mr20" placeholder="选择人员状态">
					<el-option v-for="item in items" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-select v-model="value3" @change="healthStateChoose" multiple collapse-tags class="mr20" placeholder="选择健康证状态">
					<el-option v-for="state in states" :key="state.value" :label="state.label" :value="state.value"></el-option>
				</el-select>
				<el-button @click="reset">重置</el-button>
			</div>
			<div class="main-btn">
				<el-button class="selectHeight" @click="personAdd" type="primary">
					<i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
				</el-button>
				<el-button @click="exportSels" type="primary" class="mr30" style="float:right;">导出</el-button>
			</div>
			<div class="mb20">
				<!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
				<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-click="getDataRow">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="realName" label="姓名" width="120">
					</el-table-column>
					<el-table-column prop="post" label="职务" width="120">
					</el-table-column>
					<el-table-column prop="mobile" label="手机(账号)" width="120">
					</el-table-column>
					<el-table-column prop="permissions" label="业务权限" width="120">
					</el-table-column>
					<el-table-column label="健康证截止有效期" width="180">
						<template slot-scope="scope">{{ scope.row.date }}</template>
					</el-table-column>
					<el-table-column prop="healthCertificateState" label="健康证状态" width="120">
						<span v-if="difftime==='normal'" class="health-certificate-normal">正常</span>
						<span v-else-if="difftime==='expired'" class="health-certificate-expired">已过期</span>
						<span v-else class="health-certificate-soon-expire">即将过期</span>
					</el-table-column>
					<el-table-column prop="avaliable" label="人员状态" width="120">
						<yb-state-switch></yb-state-switch>
					</el-table-column>
					<el-table-column label="最后更新时间" width="120" sortable="custom">
						<template slot-scope="scope">{{ scope.row.date }}</template>
					</el-table-column>
					<el-table-column label="操作" min-width="200">
						<template slot-scope="scope">
							<a href="javascript:;" class="operate-a" @click="personEdit(scope.row.id)">编辑</a>
							<a href="javascript:;" class="operate-a" @click="personDetail(scope.row.id)">查看详情</a>
							<a href="javascript:;" class="operate-a" @click="pwdReset">重置密码</a>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-bottom:130px;"></ybPagination>
		</div>
	</div>
</template>
<script>
import * as api from "api/com";
import ybPagination from "components/ybPagination";
import ybStateSwitch from "components/ybStateSwitch";
export default {
  name: "personList",
  components: {
    ybPagination,
    ybStateSwitch
  },
  data() {
    return {
      input: "",
      value1: "",
      options: [
        {
          value: "选项1",
          label: "人员管理"
        },
        {
          value: "选项2",
          label: "餐厨垃圾"
        },
        {
          value: "选项3",
          label: "配置"
        }
      ],
      value2: "",
      items: [
        {
          value: 1,
          label: "启用"
        },
        {
          value: 0,
          label: "禁用"
        }
      ],
      value3: "",
      states: [
        {
          value: "normal",
          label: "正常"
        },
        {
          value: "expired",
          label: "已过期"
        },
        {
          value: "soonExpire",
          label: "即将过期"
        }
      ],
      avaliable: true,
      tableData: [],
      multipleSelection: [],
      dataRow: {
        id: ""
      },
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 10
      }
    };
  },
  computed: {
    // 计算健康证状态
    difftime: function(healthCertificateValidityPeriod) {
      let today = new Date().getTime();
      let expirationDate = new Date(healthCertificateValidityPeriod).getTime();
      let dueTime = (expirationDate - today) / 1000 / 3600 / 24 / 30;
      if (dueTime <= 0) {
        // 已过期
        return "expired";
      } else if (dueTime > 1) {
        // 正常
        return "normal";
      } else {
        // 即将过期
        return "soonExpire";
      }
    }
  },
  methods: {
    // 搜索
    search() {
      if (this.input) {
        this.tableRefresh();
      }
    },
    // 权限筛选
    permissionsChoose(val) {},
    // 人员状态筛选
    avaliableChoose(val) {},
    // 健康证状态筛选
    healthStateChoose(val) {},
    // 重置
    reset() {
      this.input = "";
      this.value1 = "";
      this.value2 = null;
      this.value3 = "";
      this.tableRefresh();
    },
    // 新增按钮
    personAdd() {
      this.$router.push({ name: "person.addAndEdit", query: { type: "add" } });
    },
    // toggleSelection(rows) {
    //     if(rows) {
    //         rows.forEach(row => {
    //             this.$refs.multipleTable.toggleRowSelection(row);
    //         });
    //     } else {
    //         this.$refs.multipleTable.clearSelection();
    //     }
    // },
    // 表格中选中的项
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出选中的项
    exportSels() {
      // console.log(this.multipleSelection);
    },
    // 最后更新日期排序处理
    sortChange(column, prop, order) {
      console.log("column: " + column, "prop: " + prop, "order: " + order);
    },
    // 编辑按钮
    personEdit(id) {
      this.$router.push({
        name: "person.addAndEdit",
        query: { type: "edit", id: id }
      });
    },
    // 查看详情
    personDetail(id) {
      this.$router.push({ name: "person.detail", query: { id: id } });
    },
    // 单击行的数据
    getDataRow(row) {
      this.dataRow = row;
    },

    // 表格数据刷新重载
    tableRefresh() {
      api
        .getEmployeeList(this.page.pageNum, this.input, this.page.pageSize)
        .then(res => {
          this.tableData = res.data.records;
          console.log(res);
          this.page.total = parseInt(res.data.total);
        })
        .catch(err => {});
    },
    // 重置密码
    pwdReset() {
      let htmlMsg =
        '<p style="font-size:14px;color:#666666">确认重置密码?</p><p style="font-size:12px;color:#999999;">密码将被重置为: 111111</p>';
      this.$options.methods.getDataRow();
      api.resetPwd(this.dataRow.id).then(res => {
        this.$options.methods.pwdResetMsg();
      });
    },
    // 重置密码弹框
    pwdResetMsg() {
      let htmlMsg =
        '<p style="font-size:14px;color:#666666">确认重置密码?</p><p style="font-size:12px;color:#999999;">密码将被重置为: 111111</p>';
      this.$confirm(htmlMsg, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "重置成功!",
            center: true
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
            center: true
          });
        });
    },
    // 页数改变
    pageCurrentChange(num) {
      if (num !== this.page.pageNum) {
        this.page.pageNum = num;
        this.tableRefresh();
      }
    },
    // 页数据量改变
    pageSizeChange(size) {
      if (size !== this.page.pageSize) {
        this.page.pageSize = size;
        this.tableRefresh();
      }
    }
  },
  created() {
    return
    // api.login({
    //     userName: "13324452967",
    //     password: "666666"
    // }).then(r => {
    // }).catch(err => {});

    this.tableRefresh();
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.wrap {
  width: calc(100% - 40px);
  padding: 0 20px;
  height: 100%;
  background: #f6f6f6;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
    }
  }
  .innerBox {
    width: calc(100% - 60px);
    padding: 20px 30px;
    height: calc(100% - 125px);
    background: #fff;
    border-radius: 10px;
    .main-btn {
      margin: 20px 0;
    }
    .health-certificate-base-style {
      display: inline-block;
      box-sizing: border-box;
      height: 20px;
      border-radius: 2px;
      font-size: 12px;
      line-height: 18px;
    }
    .health-certificate-normal {
      @extend .health-certificate-base-style;
      width: 40px;
      border: 1px solid #70ce97;
      background-color: #eafff3;
      color: #70ce97;
    }
    .health-certificate-expired {
      @extend .health-certificate-base-style;
      width: 50px;
      border: 1px solid #ef755f;
      background-color: #fff5f1;
      color: #ef755f;
    }
    .health-certificate-soon-expire {
      @extend .health-certificate-base-style;
      width: 60px;
      border: 1px solid #f5a623;
      background-color: #fff8e4;
      color: #f5a623;
    }
  }
}
</style>